import site from '../index';

const pageRemoval = (store) => (next) => (action) => {
  if (action.type !== site.actionTypes.DELETE_PAGE) {
    next(action);
    return;
  }

  const prevState = store.getState();
  const { pageId } = action.payload;
  const targetPage = site.selectors.getPage(prevState, pageId);

  next(action);

  const state = store.getState();
  const pages = site.selectors.getPages(state);
  const activePageId = site.selectors.getActivePageId(state);
  const deletedPage = site.selectors.getPage(state, pageId);

  /**
   * Home page is impossible to delete, if page is deleted then
   * it means that target page wasn't home and was successfully deleted
   */
  if (activePageId === pageId && targetPage && !deletedPage) {
    /**
     *
     * For multilngual site we should get home page of current active locale
     */
    const homePage = site.selectors.getHomePage(state, targetPage.locale);
    /**
     * If home page is missing set first page as active page
     */
    const newActivePage = homePage ? homePage.id : pages[0].id;

    store.dispatch(site.actions.setActivePage(newActivePage));
  }
};

export default pageRemoval;
